import { ExchangeRate2Response } from '@acme/api';
import { formatNumber, useModal } from '@acme/foundation';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from 'flowbite-react';
import { MouseEvent } from 'react';
import { ProviderInfo } from './providerInfo';

interface ProvidersTableProps {
  className?: string;
  providers: ExchangeRate2Response[];
  selectProvider: (
    e: MouseEvent<HTMLElement>,
    provider: ExchangeRate2Response
  ) => void;
}

export const LiquidityProvidersTable = ({
  providers,
  selectProvider,
  className,
}: ProvidersTableProps) => {
  const { openConfirmModal } = useModal();

  const handleShowProviderInfo = async (
    e: MouseEvent<HTMLElement>,
    provider: ExchangeRate2Response
  ) => {
    const confirmed = await openConfirmModal({
      title: 'Поставщик ликвидности',
      content: <ProviderInfo provider={provider} />,
      okBtn: 'Выбрать поставщика',
    });

    if (!confirmed) {
      return;
    }

    selectProvider(e, provider);
  };

  return (
    <div className={`${className}`}>
      <Table hoverable>
        <TableHead>
          <TableRow>
            <TableHeadCell>Название организации</TableHeadCell>
            <TableHeadCell>Лучший курс</TableHeadCell>
            <TableHeadCell>Доступный к заказу объем</TableHeadCell>
            <TableHeadCell />
          </TableRow>
        </TableHead>

        <TableBody>
          {providers.map((p) => (
            <TableRow
              className="cursor-pointer"
              onClick={(e) => handleShowProviderInfo(e, p)}
              key={p.id}
            >
              <TableCell>{p.name}</TableCell>
              <TableCell>
                {formatNumber(
                  Math.min(
                    ...(p.ranges ?? []).map((r) => r.price ?? 0),
                    Infinity
                  )
                )}
              </TableCell>
              <TableCell>
                {`${formatNumber(p.amount)} ${p.cryptoCurrency ?? ''}`.trim()}
              </TableCell>
              <TableCell>
                <Button
                  onClick={(e: MouseEvent<HTMLElement>) => selectProvider(e, p)}
                  color="alternative"
                >
                  Выбрать
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
